import { observable, action, runInAction } from 'mobx';

export class PositionStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable recentlyClosed = [];
    @observable history = [];

    @action getRecentlyClosed() {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;
        this.recentlyClosedWatcher = this.botStore.rootStore.db
            .collection(`users/${currentUser.uid}/botConfigs/`)
            .doc(this.botStore.currentBot)
            .collection('positions')
            .orderBy('closed_at', 'desc')
            .limit(10)
            .onSnapshot(
                snapshot => {
                    let recordSet = [];
                    snapshot.forEach(recordSnapshot => {
                        const record = { id: recordSnapshot.id, ...recordSnapshot.data() };
                        record.base = record.ccxtSymbol.split('/')[0];
                        recordSet.push(record);
                    });
                    runInAction(() => {
                        this.recentlyClosed = recordSet;
                    });
                },
                function(error) {
                    console.log(error);
                }
            );
    }

    @action async getPosition(id) {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;
        const doc = await this.botStore.rootStore.db
            .collection(`users/${currentUser.uid}/botConfigs/`)
            .doc(this.botStore.currentBot)
            .collection('positions')
            .doc(id)
            .get();
        return { ...doc.data(), id: doc.id };
    }

    @action async getHistory(cancelled) {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;

        let records = [];
        let recordSet = [];
        runInAction(() => {
            this.history = recordSet;
        });
        if (cancelled) {
            records = await this.botStore.rootStore.db
                .collection(`users/${currentUser.uid}/botConfigs/`)
                .doc(this.botStore.currentBot)
                .collection('positions')
                .where('active', '==', false)
                .orderBy('closed_at', 'desc')
                .limit(1000)
                .get();
        } else {
            records = await this.botStore.rootStore.db
                .collection(`users/${currentUser.uid}/botConfigs/`)
                .doc(this.botStore.currentBot)
                .collection('positions')
                .where('active', '==', false)
                .where('status', '==', 'COMPLETE')
                .orderBy('closed_at', 'desc')
                .limit(1000)
                .get();
        }

        records.forEach(recordSnapshot => {
            recordSet.push({ id: recordSnapshot.id, ...recordSnapshot.data() });
        });
        runInAction(() => {
            this.history = recordSet;
        });
    }

    @action stopRecentlyClosed() {
        if (this.recentlyClosedWatcher) this.recentlyClosedWatcher();
        this.recentlyClosed = [];
    }

    getPositionLogs(positionId, cb) {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;

        return this.botStore.rootStore.db
            .collection(`users/${currentUser.uid}/botConfigs/`)
            .doc(this.botStore.currentBot)
            .collection('positions')
            .doc(positionId)
            .collection('logs')
            .orderBy('date', 'desc')
            .onSnapshot(function(snapshot) {
                let recordSet = [];
                snapshot.forEach(recordSnapshot => {
                    recordSet.push({ id: recordSnapshot.id, ...recordSnapshot.data() });
                });
                cb(recordSet);
            });
    }

    queryCompletePositions = cb => {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;
        let date = new Date();
        date.setDate(date.getDate() - 14);

        return this.botStore.rootStore
            .collection(`users/${currentUser.uid}/botConfigs/`)
            .doc(this.botStore.currentBot)
            .collection('positions')
            .where('active', '==', false)
            .where('closed_at', '>=', date.getTime())
            .orderBy('closed_at', 'desc')
            .onSnapshot(
                function(snapshot) {
                    let recordSet = [];
                    snapshot.forEach(recordSnapshot => {
                        recordSet.push({ id: recordSnapshot.id, ...recordSnapshot.data() });
                    });
                    cb(recordSet);
                },
                function(error) {
                    console.log(error);
                }
            );
    };
}



// WEBPACK FOOTER //
// ./src/stores/PositionStore.js